/**
 * CARTAL — feature flags.
 *
 * Central toggles so we can temporarily hide sections from the public UI
 * without deleting any code. Every referenced component, route, and asset
 * stays intact — flipping the flag back to `true` restores the section
 * exactly as it was.
 */
export const FEATURES = Object.freeze({
  // Auctions are policy-restricted by the payment provider (Moyasar).
  // Kept in code, hidden from every public surface until we swap gateway
  // or restructure the auction flow to comply. Do NOT delete auction files.
  AUCTIONS_ENABLED: false,

  // CARTAL Guarantee (Escrow) — temporarily hidden from the public UI
  // pending a root-cause solution to the payment-provider architecture
  // (Moyasar Invoice API does not support Authorization Hold; a switch
  // to a gateway with Split Payment is under evaluation).
  //
  // Flag flipped to `false` per user directive (iter149). ALL backend
  // code, APIs, database collections, Moyasar integration, webhook
  // handler, capture/void endpoints, payments_service escrow logic,
  // EscrowTermsPage, and DealCompletionPage remain fully intact and
  // untouched — flipping this back to `true` restores every surface
  // exactly as it was.
  ESCROW_ENABLED: false,

  // "Complete the deal via CARTAL" primary CTA on the vehicle detail page.
  // Hidden from the UI per user directive (iter156). ALL backend logic,
  // the `/deal/:vehicleId` route, DealCompletionPage, payments service,
  // and every related API endpoint remain intact — flipping this back
  // to `true` restores the button exactly as it was, in the exact same
  // spot, with the exact same styling and hint text.
  COMPLETE_DEAL_CTA_ENABLED: false,
});
